import { theme, ThemeConfig } from 'antd'

export const PageTheme: ThemeConfig = {
  token: {
    colorPrimary: '#316BFF',
    colorSuccess: '#316BFF',
    colorInfo: '#316BFF',
    colorText: 'rgba(33, 41, 58, 0.88)',
  },
  components: {
    Menu: {
      colorPrimary: '#FFFFFF',
      colorText: '#FFFFFF',
      colorTextLightSolid: '#FFFFFF',
      colorBgContainer: '#316BFF',
      controlItemBgActive: 'rgba(33, 41, 58, 0.15)',
    },
    Layout: {
      headerBg: '#FFFFFF',
      siderBg: '#FFFFFF',
    },
  },
  algorithm: theme.defaultAlgorithm,
}
